module.exports = __webpack_public_path__ + "08fb3fde983e87351b1dd9146dfc2b50.jpg";